export default __webpack_public_path__ + "230fd00.png";